import type { ReactNode } from "react";
import AppLayout from "../../../../shared/components/AppLayout";
import { getLeagueTexts } from "../leagueTexts";
import "../leagues.css";

export default function LeagueLayout({ children, title }: { children: ReactNode; title?: string }) {
  const t = getLeagueTexts();
  return <AppLayout title={title || t.title} subtitle={t.subtitle}>
    <section className="league-feature">{children}</section>
  </AppLayout>;
}
